<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="page-header">
  <div>
    <h1 class="title">{{ 'SESSIONS_ADMIN.TITLE' | translate }}</h1>
    <p class="sub">{{ 'SESSIONS_ADMIN.SUBTITLE' | translate }}</p>
  </div>
</div>

<div class="user-selector-section">
  <div class="user-search">
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input
        pInputText
        [(ngModel)]="userSearch"
        placeholder="ابحث عن مستخدم بالاسم أو البريد الإلكتروني..."
        (keyup.enter)="findUsers()"
        (input)="findUsers()"
        styleClass="search-input"
      />
      <button
        *ngIf="selectedUser"
        pButton
        icon="pi pi-times"
        class="p-button-text p-button-secondary clear-btn"
        pTooltip="مسح الاختيار"
        (click)="clearSelection()"
      ></button>
    </div>
  </div>

  <div class="candidates" *ngIf="candidateUsers.length > 0">
    <div class="candidate-item" *ngFor="let u of candidateUsers" (click)="pickUser(u)">
      <div class="user-avatar">{{ (u.username?.[0] || 'U') | uppercase }}</div>
      <div class="user-info">
        <div class="user-name">{{ u.fullName || u.username }}</div>
        <div class="user-meta">{{ u.email || '—' }}</div>
      </div>
      <i class="pi pi-chevron-left"></i>
    </div>
  </div>

  <div class="selected-user" *ngIf="selectedUser">
    <div class="selected-user-card">
      <div class="selected-user-info">
        <div class="user-avatar large">{{ (selectedUser.username?.[0] || 'U') | uppercase }}</div>
        <div class="user-details">
          <div class="user-name">{{ selectedUser.fullName || selectedUser.username }}</div>
          <div class="user-meta">
            <i class="pi pi-envelope"></i>
            {{ selectedUser.email || '—' }}
          </div>
        </div>
      </div>
      <button
        pButton
        icon="pi pi-times"
        class="p-button-text p-button-secondary"
        pTooltip="إلغاء الاختيار"
        (click)="clearSelection()"
      ></button>
    </div>
    <div class="session-stats">
      <div class="stat-card stat-card--success">
        <div class="stat-icon">
          <i class="pi pi-check-circle"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ activeSessionsCount }}</div>
          <div class="stat-label">جلسات نشطة</div>
        </div>
      </div>
      <div class="stat-card stat-card--danger">
        <div class="stat-icon">
          <i class="pi pi-times-circle"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ inactiveSessionsCount }}</div>
          <div class="stat-label">جلسات منتهية</div>
        </div>
      </div>
      <div class="stat-card stat-card--info">
        <div class="stat-icon">
          <i class="pi pi-list"></i>
        </div>
        <div class="stat-content">
          <div class="stat-value">{{ rows.length }}</div>
          <div class="stat-label">إجمالي الجلسات</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="sessions-section" *ngIf="selectedUserId">
  <div class="sessions-header">
    <div>
      <h3>الجلسات</h3>
      <p class="sessions-subtitle">عرض وإدارة جميع جلسات المستخدم</p>
    </div>
    <div class="actions">
      <button
        pButton
        label="إنهاء الكل"
        icon="pi pi-ban"
        class="p-button-warning"
        (click)="revokeAll()"
        [disabled]="activeSessionsCount === 0"
        pTooltip="إنهاء جميع الجلسات النشطة"
      ></button>
    </div>
  </div>

  <p-table
    [value]="rows"
    styleClass="sessions-table"
    [tableStyle]="{ 'min-width': '70rem' }"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 200px">معرف الجلسة</th>
        <th>الجهاز</th>
        <th style="width: 150px">عنوان IP</th>
        <th style="width: 180px">تاريخ الإنشاء</th>
        <th style="width: 180px">تاريخ الانتهاء</th>
        <th style="width: 120px">الحالة</th>
        <th style="width: 120px" class="text-end">إجراءات</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-r>
      <tr>
        <td>
          <code class="session-id">{{ r.id }}</code>
        </td>
        <td>
          <div class="device-info">
            <i class="pi" [ngClass]="getDeviceIcon(r.device)"></i>
            <span>{{ r.device || '—' }}</span>
          </div>
        </td>
        <td>
          <span class="ip-address">{{ r.ipAddress || '—' }}</span>
        </td>
        <td>
          <div class="date-cell">
            <div class="date">{{ r.createdAt | date : 'yyyy-MM-dd' }}</div>
            <div class="time">{{ r.createdAt | date : 'HH:mm:ss' }}</div>
          </div>
        </td>
        <td>
          <div class="date-cell" *ngIf="r.expiresAt; else noExpiry">
            <div class="date">{{ r.expiresAt | date : 'yyyy-MM-dd' }}</div>
            <div class="time">{{ r.expiresAt | date : 'HH:mm:ss' }}</div>
          </div>
          <ng-template #noExpiry>
            <span class="text-muted">لا ينتهي</span>
          </ng-template>
        </td>
        <td>
          <p-tag
            [value]="getStatusLabel(r)"
            [severity]="getStatusSeverity(r)"
          ></p-tag>
        </td>
        <td class="text-end">
          <div class="actions">
            <button
              pButton
              icon="pi pi-times"
              class="icon-btn danger"
              pTooltip="إنهاء الجلسة"
              (click)="revoke(r)"
              [disabled]="r.isRevoked || isExpired(r)"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" style="text-align: center; padding: 2rem">
          <div style="color: #9ca3af">لا توجد جلسات</div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="empty-state" *ngIf="!selectedUserId">
  <div class="empty-icon">
    <i class="pi pi-users"></i>
  </div>
  <h3>اختر مستخدم لعرض جلساته</h3>
  <p>ابحث عن مستخدم في الحقل أعلاه لعرض وإدارة جلساته النشطة</p>
</div>
